import "core-js/modules/es6.object.assign";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

var _TRANSITIONS;

// Owner and community rules shared by the Meteor server (enforcement) and the Quasar client (UI).
// Pure functions only: no collections, no Meteor calls, so both sides and the tests can import it.
// Client import: `api/owners/rules` (webpack alias). See docs/claude/done/owner-registration-and-community-management-plan.md
import { REJECT_COMMENT_MAX_LENGTH, ORGANIZATION_MAX_LENGTH } from "../core/limits";
export var OWNER_STATUS = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  REJECTED: 'rejected'
}; // KV keys owned by this feature

export var KV_POLYGON_LISTS = 'POLYGON_LISTS';
export var KV_MIGRATION_OWNER_STATUS = 'MIGRATION_OWNER_STATUS';
export var KV_MIGRATION_OWNER_STATUS_DRY_RUN = 'MIGRATION_OWNER_STATUS_DRY_RUN'; // a rejection or deletion reason the owner gets to read: 1-1000 characters after trimming

export var isValidRejectComment = function isValidRejectComment(comment) {
  var text = typeof comment === 'string' ? comment.trim() : '';
  return text.length > 0 && text.length <= REJECT_COMMENT_MAX_LENGTH;
};

var profileOf = function profileOf(user) {
  return user && user.profile || {};
};

export var isOwner = function isOwner(user) {
  return profileOf(user).owner === true;
};
export { isAdmin, isSuperadmin } from "../core/roles"; // null for non-owners; a missing status on an owner counts as pending

export var ownerStatusOf = function ownerStatusOf(user) {
  if (!isOwner(user)) return null;
  var status = profileOf(user).ownerStatus;
  return Object.values(OWNER_STATUS).includes(status) ? status : OWNER_STATUS.PENDING;
};
export var isVerifiedOwner = function isVerifiedOwner(user) {
  return ownerStatusOf(user) === OWNER_STATUS.VERIFIED;
}; // Review status of a community by an admin (D65). Non-blocking: a community of any status works for its owner and
// fans. Communities from before the status field count as verified when `verified` is true, otherwise as pending.

export var COMMUNITY_STATUS = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  REJECTED: 'rejected'
};
export var communityStatusOf = function communityStatusOf(land) {
  if (!land) return null;
  if (Object.values(COMMUNITY_STATUS).includes(land.reviewStatus)) return land.reviewStatus;
  return land.verified === true ? COMMUNITY_STATUS.VERIFIED : COMMUNITY_STATUS.PENDING;
}; // allowed status changes by an admin: any status to any other, so mistakes can be corrected (D46)

var TRANSITIONS = (_TRANSITIONS = {}, _defineProperty(_TRANSITIONS, OWNER_STATUS.PENDING, [OWNER_STATUS.VERIFIED, OWNER_STATUS.REJECTED]), _defineProperty(_TRANSITIONS, OWNER_STATUS.REJECTED, [OWNER_STATUS.VERIFIED, OWNER_STATUS.PENDING]), _defineProperty(_TRANSITIONS, OWNER_STATUS.VERIFIED, [OWNER_STATUS.PENDING, OWNER_STATUS.REJECTED]), _TRANSITIONS);
export var canTransition = function canTransition(from, to) {
  return (TRANSITIONS[from] || []).includes(to);
}; // the dashboard notification shows until dismissed and again after every status change (D35)

export var hasUnseenOwnerNotice = function hasUnseenOwnerNotice(user) {
  var p = profileOf(user);
  if (!isOwner(user) || !p.ownerStatusAt) return false;
  return !p.ownerNoticeSeenAt || new Date(p.ownerNoticeSeenAt) < new Date(p.ownerStatusAt);
}; // The client sends the whole profile at sign-up. For owners, the status fields are always set
// here, whatever the client sent; admin and superadmin can never be self-assigned. The organisation
// type is gone (D76): a sent organizationTag is dropped.

export var sanitizeNewUserProfile = function sanitizeNewUserProfile(profile, now) {
  var p = Object.assign({}, profile);
  delete p.admin;
  delete p.superadmin;
  delete p.demoAdmin;
  delete p.ownerStatusBy;
  delete p.ownerFeedback;
  delete p.ownerNoticeSeenAt;
  delete p.communityNotices;
  delete p.organizationTag;

  if (p.owner === true) {
    p.ownerStatus = OWNER_STATUS.PENDING;
    p.ownerStatusAt = now;
  } else {
    delete p.ownerStatus;
    delete p.ownerStatusAt;
  }

  return p;
}; // owners must name their organisation (1-60 characters after trimming)

export var isValidOrganization = function isValidOrganization(organization) {
  var text = typeof organization === 'string' ? organization.trim() : '';
  return text.length > 0 && text.length <= ORGANIZATION_MAX_LENGTH;
}; // one-time migration of existing owners (D5): everyone becomes pending, owners who are admin too (D75,
// reverses D28). Every owner is verified by an admin, by hand.

export var migrationStatusFor = function migrationStatusFor() {
  return OWNER_STATUS.PENDING;
}; // Email domain as a trust signal on the admin review list (D40): an organisation's own domain
// versus a personal mailbox. The list is a hint for the admin, never a rule.

export var PERSONAL_EMAIL_DOMAINS = ['gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.nl', 'outlook.com', 'outlook.nl', 'live.com', 'live.nl', 'msn.com', 'icloud.com', 'me.com', 'yahoo.com', 'yahoo.de', 'gmx.de', 'gmx.net', 'web.de', 't-online.de', 'kpnmail.nl', 'ziggo.nl', 'planet.nl', 'home.nl', 'xs4all.nl', 'hetnet.nl', 'casema.nl', 'proton.me', 'protonmail.com'];
export var emailDomain = function emailDomain(email) {
  var at = typeof email === 'string' ? email.lastIndexOf('@') : -1;
  return at === -1 ? '' : email.slice(at + 1).trim().toLowerCase();
};
export var isPersonalEmailDomain = function isPersonalEmailDomain(domain) {
  return PERSONAL_EMAIL_DOMAINS.includes(domain);
}; // Polygon lists (KV POLYGON_LISTS) are for every verified owner, all of them (D77): browsing a list is part of
// creating a community, which only verified owners can do. Waiting and rejected owners get none.

export var canUsePolygonLists = function canUsePolygonLists(user) {
  return isVerifiedOwner(user);
};